import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const useContactsDescriptionQuery = () => {
    return useQuery({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: ["contactsPersonas"],
        queryFn({ signal }) {
            return salesApiService.contacts.fetchContactsDescription({
                cancellation: signal,
            });
        },
    });
};

export default useContactsDescriptionQuery;
